import { zodResolver } from '@hookform/resolvers/zod'
import { Box, Button, Stack } from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import { observer } from 'mobx-react'
import React from 'react'
import { useForm } from 'react-hook-form'
import z from 'zod'
import CustomAccordion from '../../../../../components/customElements/RequestDataAccordions/utils/CustomAccordion'
import { useInvalidateQueries } from '../../../../../hooks/useInvalidateQueries'
import { markOrderAsDuplicateDealer } from '../../../../../services/ApiService'
import { notifySuccess } from '../../../../../services/ToastifyService/ToastifyService'
import FormInput from '../../../../SingleRequestPage/components/SingleRequestDrawer/elements/FormInput'
import { RequestType } from '../../../../SingleRequestPage/types/Request.type'
import { newRequestDrawerStore } from '../../../stores/NewRequestDrawerStore'

const toDuplicateNewSchema = z.object({
  comment: z.string().refine((val) => !!val.trim()),
})

type ToDuplicateNewForm = z.infer<typeof toDuplicateNewSchema>

interface ToDuplicateNewProps {
  request: RequestType
}

const ToDuplicateNew: React.FC<ToDuplicateNewProps> = ({ request }) => {
  const invalidate = useInvalidateQueries()
  const {
    control,
    formState: { isValid },
    watch,
  } = useForm<ToDuplicateNewForm>({
    mode: 'onChange',
    defaultValues: {
      comment: '',
    },
    resolver: zodResolver(toDuplicateNewSchema),
  })

  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['mark-as-duplicate-dealer'],
    mutationFn: () =>
      markOrderAsDuplicateDealer({
        orderId: request.id,
        comment: watch('comment'),
      }),
    onSuccess: () => {
      newRequestDrawerStore.closeDrawer()
      invalidate(['requests-table'])
      notifySuccess('Заявка обновлена')
    },
  })

  return (
    <Stack gap={'24px'}>
      {/* @ts-ignore */}
      <CustomAccordion
        defaultOpenState
        summary={'Причина перевода заявки в дубликат'}
      >
        <FormInput
          control={control}
          fullWidth
          name='comment'
          label={''}
          placeholder='Введите комментарий'
          multiline
          rows={3}
        />
      </CustomAccordion>
      <Box px={'16px'}>
        <Button
          variant='contained'
          onClick={() => mutateAsync()}
          loading={isPending}
          disabled={!isValid}
          fullWidth
        >
          Перевести в дубликат
        </Button>
      </Box>
    </Stack>
  )
}

export default observer(ToDuplicateNew)
